import React from 'react';
import { Card, Result, Typography, Space } from 'antd';
import { LockOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface NoAccessCardProps {
  compact?: boolean;
  message?: string;
}

export const NoAccessCard: React.FC<NoAccessCardProps> = ({
  compact = false,
  message
}) => {

  return (
    <Card 
      style={{ 
        margin: compact ? '8px' : '0',
        width: '100%'
      }}
      styles={{
        body: { 
          padding: compact ? '24px' : '48px 24px',
          display: 'flex',
          justifyContent: 'center'
        }
      }}
    >
      <div style={{ maxWidth: '800px', width: '100%' }}>
        <Result
          status="403"
          icon={<LockOutlined style={{ color: 'var(--color-warning)' }} />}
          title="Доступ ограничен"
          subTitle={
            <Space orientation="vertical" size="small" style={{ marginTop: '16px' }}>
              <Text type="secondary">
                {message || 'У вас нет прав для просмотра этого раздела.'}
              </Text>
              <div style={{ marginTop: '16px', padding: '12px', background: 'var(--color-bg-primary)', borderRadius: '4px' }}>
                <Text type="secondary" style={{ fontSize: '12px' }}>
                  💡 Если вам нужен доступ к этому разделу, обратитесь к администратору системы
                </Text>
              </div>
            </Space>
          }
        />
      </div>
    </Card>
  );
};


